import {
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import React, { useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import styled from "styled-components";

const useStyles = makeStyles((theme) => ({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "500px",
    margin: "20px auto",
    padding: "20px",
    boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.2)",
    borderRadius: "5px",
  },
  formGroup: {
    margin: "10px 0",
  },
  submitButton: {
    marginTop: "20px",
    height: "48px",
    cursor: "pointer",
    border: "none",
    borderRadius: "5px",
    backgroundColor: "#000",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "600",
    transition: "all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s",
    "&:hover": {
      backgroundColor: "#141414",
    },
  },
  formTitle: {
    textAlign: "center",
    marginBottom: "20px",
    color: "#424770",
  },
}));

const SubmitButton = styled.button`
  height: 48px;
  margin-top: 20px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  background-color: #000;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  &:hover {
    background-color: #141414;
  }
`;

const AddLocationVendors = () => {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    name: "",
    code: "",
    expirationDate: "",
  });
  const [plates, setPlates] = useState([]);
  const [plateInput, setPlateInput] = useState({
    number: "",
    state: "",
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { locationId } = useParams();
  const history = useHistory();
  const location = useLocation();

  // Get query params
  const queryParams = new URLSearchParams(location.search);
  const locationName = queryParams.get("locationName");

  console.log("locationName", locationName);

  const handleChange = (name) => (event) => {
    setFormData({ ...formData, [name]: event.target.value });
  };

  const handlePlateInputChange = (field) => (event) => {
    setPlateInput({ ...plateInput, [field]: event.target.value });
  };

  const addPlate = () => {
    if (plateInput.number && plateInput.state) {
      setPlates([
        ...plates,
        { number: plateInput.number, state: plateInput.state },
      ]);
      setPlateInput({ number: "", state: "" });
    }
  };

  const removePlate = (index) => {
    const updatedPlates = [...plates];
    updatedPlates.splice(index, 1);
    setPlates(updatedPlates);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");

    // Basic validation
    if (!formData.name || !formData.code || !formData.expirationDate) {
      console.log("line 80", formData);
      setError("All fields are required");
      return;
    }

    setIsLoading(true);

    // Include plates in the data being sent
    const dataToSend = {
      ...formData,
      plates,
    };

    // use react router hooks to get location id from url
    fetch(`/api/v1/locations/${locationId}/vendors/add`, {
      method: "POST",
      body: JSON.stringify(dataToSend),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error("Failed to add vendor");
        }
      })
      .then((data) => {
        console.log(data);
        console.log("Vendor added successfully", data.message);
        setIsLoading(false);
        // Reset form after successful submission
        setFormData({
          name: "",
          code: "",
          expirationDate: "",
        });
        setPlates([]);
        history.push(`/management/locations/${locationId}`);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        setError("Failed to add vendor. Please try again.");
      });
  };

  return (
    <div className={classes.formContainer}>
      <h2 className={classes.formTitle} style={{ textTransform: "capitalize" }}>
        Add Vendor for {locationName ? locationName : "Location"}
      </h2>
      <form onSubmit={handleSubmit}>
        <div className={classes.formGroup}>
          <TextField
            label="Vendor Name"
            variant="outlined"
            fullWidth
            onChange={handleChange("name")}
            value={formData.name}
            disabled={isLoading}
            required
          />
        </div>

        <div className={classes.formGroup}>
          <TextField
            label="Vendor Code"
            variant="outlined"
            fullWidth
            onChange={handleChange("code")}
            value={formData.code}
            disabled={isLoading}
            required
          />
        </div>

        <div className={classes.formGroup}>
          <TextField
            label="Expiration Date"
            type="date"
            variant="outlined"
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleChange("expirationDate")}
            value={formData.expirationDate}
            disabled={isLoading}
            required
          />
        </div>

        {error && (
          <div
            style={{
              fontSize: 12,
              color: "red",
              textAlign: "center",
              marginTop: "10px",
            }}
          >
            {error}
          </div>
        )}

        <Divider style={{ margin: "20px 0" }} />

        <h3 style={{ margin: "10px 0" }}>Vendor Plates</h3>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "10px",
          }}
        >
          <TextField
            label="Plate Number"
            variant="outlined"
            // max character length is 8 and uppercase for all characters
            inputProps={{
              maxLength: 8,
              onChange: (e) => {
                e.target.value = e.target.value.toUpperCase();
              },
            }}
            value={plateInput.number}
            onChange={handlePlateInputChange("number")}
            disabled={isLoading}
          />
          <TextField
            label="Plate State"
            variant="outlined"
            // max character length is 2 and uppercase for all characters
            inputProps={{
              maxLength: 2,
              onChange: (e) => {
                e.target.value = e.target.value.toUpperCase();
              },
            }}
            value={plateInput.state}
            onChange={handlePlateInputChange("state")}
            disabled={isLoading}
          />
          <button
            type="button"
            onClick={addPlate}
            style={{
              padding: "0 15px",
              backgroundColor: "#000",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              height: "48px",
              marginBottom: "10px",
            }}
            disabled={isLoading}
          >
            Add
          </button>
        </div>

        <TableContainer
          component={Paper}
          style={{
            maxHeight: "500px",
            overflow: "auto",
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Plate Number</strong>
                </TableCell>
                <TableCell>
                  <strong>Plate State</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {plates.length > 0 ? (
                plates.map((plate, index) => (
                  <TableRow key={index}>
                    <TableCell>{plate.number}</TableCell>
                    <TableCell>{plate.state}</TableCell>
                    <TableCell
                      style={{
                        textAlign: "right",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div
                        size="small"
                        onClick={() => removePlate(index)}
                        disabled={isLoading}
                        style={{
                          cursor: "pointer",
                          color: "#000",
                          borderRadius: "5px",
                          padding: "5px",
                          width: "48px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <DeleteIcon fontSize="small" style={{ color: "red" }} />
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No plates added yet
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <SubmitButton
          style={{
            width: "100%",
            marginTop: "20px",
          }}
          type="submit"
          disabled={isLoading}
        >
          {isLoading ? "Submitting..." : "Add Vendor"}
        </SubmitButton>
      </form>
    </div>
  );
};

export default AddLocationVendors;
